import { useTranslation } from 'react-i18next'

const NoOpinionsDadEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="noopinionsdad-end-title"
      {...props}
    >
      <title id="noopinionsdad-end-title">{t('antagonists:noOpinionsDad:components:end')}</title>
      <defs>
        <clipPath id="noopinionsdad-a">
          <path
            d="M1345.64 438.42s30.11 50.22 92.44 41.01c40.11-5.93 36.45-24.54 36.45-24.54s77.1 25.17 101.44 47.41 40.67 70.67 63.6 118.63c22.93 47.96 37.79 115.03 8.6 128.95-29.2 13.9-86.19 13.69-86.19 13.69s3.11 79.68 7.9 126.15c5.15 49.86 9.94 74.59 9.94 74.59s-39.01 24.05-158.56 19.88c-119.56-4.17-158.73-15.21-158.73-15.21s-7.63-28.8-3.45-59.38c4.17-30.58 13.46-130.22 13.46-130.22s-33.53 9.69-50.75-116.77c-10.49-77.07-22.91-128.59 8.35-166.82 20.28-24.81 65.72-30.43 82.03-39.61 22-12.4 33.52-17.72 33.52-17.72l-.04-.04Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
      </defs>
      <path
        d="M1277.93 863.62s-16.72 118.72-18.39 178.92c-1.67 60.2 36.6 230.77 36.6 260.87s-5.02 136.28 4.18 195.64c9.2 59.36 31.6 142.64 31.6 142.64l80.95-2.99s-4.7-135.46-2.2-190.64-10.11-121.05-6.76-166.2c3.35-45.14 18.29-183.12 18.29-183.12s67.94 191.68 80.48 228.47c12.54 36.79-4 98.12 1.86 164.17 5.85 66.05 5.83 141.52 5.83 141.52l80.29 4.79s26.76-106.87 27.59-191.32c.83-84.45-12.76-148.43-12.76-205.3s-9.85-192.71-24.88-268.79c-15.05-76.08-37.62-121.24-37.62-121.24l-265.04 12.54-.02.04Z"
        style={{
          fill: '#dfbe84',
        }}
      />
      <path
        d="M1354.71 370.07s1.33 55.63-5.91 66.48c-7.23 10.85-68.09 39.29-68.09 39.29l11.34 53.3 236.2-.61-12.48-49.42s-48.17-22.15-52.39-36.02c-4.22-13.86-.23-74.25-.23-74.25l-108.46 1.21h.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1371.2 198.17c-21 3.16-68.7 32.99-56.22 79.41 2.22 8.24 14.11 20.3 18.86 40.07 3.11 12.88 15.91 65.21 15.91 65.21l129.37-42.89s-.66-9.28 4.09-23.93c4.75-14.66 18.63-27.76 14.28-41.62-4.36-13.86-39.01-63.41-57.18-68.34-38.02-10.3-51.2 4.34-60.18 1.7-9.51-2.76-2.23-10.6-8.9-9.6l-.02-.02Z"
        style={{
          fill: '#c0c2c4',
        }}
      />
      <path
        d="M1406.21 251.48c-17.8 1.46-28.9-4.56-40.12.95-15.09 7.38-12.38 18.88-15.22 29.58-5.93 22.31-11.32 28.18-7.84 47.68 3.48 19.5 16.04 56.71 26.15 75.87 10.11 19.16 20.2 15.68 32.76 16.72 12.55 1.04 32.42.7 40.77-12.89 8.37-13.6 25.43-41.81 28.23-61.33 2.78-19.52 1.04-51.6-7.01-71.84-4.03-10.15-3.86-18.95-20.24-26.66-12.23-5.76-27.95 1.16-37.49 1.93h.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1346.15 332.9s-12.82-5.55-21.19-.68c-8.37 4.89-1.4 25.43 1.74 35.2 3.14 9.75 6.63 11.49 11.49 10.81 4.89-.7 10.45-4.18 10.45-4.18l-2.52-41.15h.02Zm128.8-4.76s6.97-7.31 15.34-2.44c8.37 4.89 1.4 25.43-1.74 35.2-3.14 9.75-6.63 11.49-11.49 10.81-4.89-.7-10.45-4.18-10.45-4.18l8.37-39.39h-.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1415.43 346.66c7.1 1.95 17.36 11.72 24.16 18.2 7.71 7.35 18.9-1.67 28.19-23.42 5.87-13.77 2.31-45.22 2.31-45.22l14.13-1.67s-6.85 15.3-6.85 23.61-3.12 18.9-4.51 27.44 6.12 26.36 2.65 39.97-20.15 30.73-28.69 42.26-24.24 13.78-36.24 13.31c-12-.47-29.9 2.35-41.2-14.03s-25.43-33.84-27.04-47.68c-1.61-13.84.13-31.89-2.8-50.94-1.76-11.42-5.72-32.97-5.25-33.65s13.61-2.23 13.61-2.23-3.75 17.53-3.28 25.15 1.02 14.28 3.11 25.58 7.38 16.8 14.98 13.67c8.22-3.37 23.97-8.26 29.29-10.24 9.92-3.69 10.02 3.48 13.94 3.24 3.69-.23 5.49-4.47 9.51-3.35h-.02Zm-8.86 6.91c-6.46.32-17.23 3.52-30.26 9.22-11.83 5.19-10.19 22.85-1.72 26.85 16.4 7.73 23.06-2.23 32.51-1.78 9.47.45 13.22 13.08 25.98 4.98 9.52-6.04-.23-20.37-5.17-25.83-4.13-4.56-14.52-13.77-21.36-13.43l.02-.02Z"
        style={{
          fill: '#c0c2c4',
        }}
      />
      <path
        d="M1396.01 360.03c4.3-1.06 8.71 2.08 10.19 1.93 1.5-.15 7.2-1.8 11.97 1.48 8.29 5.68 10.43 5.45 10.83 8.29.57 3.96-2.2 16.28-24.35 12.78-9.41-1.48-25.85-13.18-21.72-21.72 1.51-3.12 8.77-1.72 13.07-2.78l.02.02Z"
        style={{
          fill: '#f4a019',
        }}
      />
      <path
        d="M1377.66 301.9c-3.62 1.25-5.32 4.54-3.96 8.05 1.36 3.48 4.15 4.13 7.46 3.22 3.9-1.08 5.3-4.15 4.26-7.88-.72-2.63-4.05-4.68-7.76-3.39Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1364.61 307.6 22.17-7.31-.54-6.82-23.07 9.23 1.44 4.9zm21.4-21.09s-12.48-1.87-19.67.87c-7.2 2.76-11.36 9.41-11.36 9.41l-2.84-3.45s2.88-8.99 13.41-13.29c5.47-2.23 20.2-2.69 20.2-2.69l.27 9.15Zm48.57 15.49c3.62 1.25 5.32 4.54 3.96 8.05-1.36 3.48-4.15 4.13-7.46 3.22-3.9-1.08-5.3-4.15-4.26-7.88.72-2.63 4.05-4.68 7.76-3.39Z"
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1447.28 306.62-22.85-6.33 1.99-6 21.94 6.95-1.08 5.38zm-23.59-20.81s13.27-1.59 20.72.42c7.44 2.01 12.57 6.53 12.57 6.53l1.87-4.58s-3.03-6.04-13.94-9.24c-5.68-1.67-22.53-2.69-22.53-2.69l1.33 9.58-.02-.02Z"
      />
      <path
        d="M1345.64 438.42s30.11 50.22 92.44 41.01c40.11-5.93 36.45-24.54 36.45-24.54s77.1 25.17 101.44 47.41 40.67 70.67 63.6 118.63c22.93 47.96 37.79 115.03 8.6 128.95-29.2 13.9-86.19 13.69-86.19 13.69s3.11 79.68 7.9 126.15c5.15 49.86 9.94 74.59 9.94 74.59s-39.01 24.05-158.56 19.88c-119.56-4.17-158.73-15.21-158.73-15.21s-7.63-28.8-3.45-59.38c4.17-30.58 13.46-130.22 13.46-130.22s-33.53 9.69-50.75-116.77c-10.49-77.07-22.91-128.59 8.35-166.82 20.28-24.81 65.72-30.43 82.03-39.61 22-12.4 33.52-17.72 33.52-17.72l-.04-.04Z"
        style={{
          fill: '#009e8b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#noopinionsdad-a)',
        }}
      >
        <path
          d="M1094.29 540.32s58.7-39.71 148.45-10.36c89.77 29.35 124.29 48.34 210.6 51.79s217.51-53.51 217.51-53.51l-5.17-195.07-611.1 12.08 39.71 195.07Z"
          style={{
            fill: '#62ac6d',
          }}
        />
        <path
          d="M1420.4 488.28c40.31.32 55.67-12.21 61.43-22.51 5.76-10.3 4.54-22.12 4.54-22.12l-151.82-27.87.61 17.57s11 54.33 85.25 54.93Z"
          style={{
            fill: '#e5352d',
          }}
        />
      </g>
      <path
        d="M1420.57 652.87c2.78 5.57 4.17 19.47 2.78 34.06s-7.56 20.2-7.56 20.2-11.59-1.7-25.43-2.2c-13.31-.45-29.35-5.43-38.4-9.26-18.06-7.65-16.51-34.71-16.51-34.71s12.78-5.47 24.6-2.69c11.82 2.78 18.12-.57 25.77-2.65 7.65-2.08 34.77-2.78 34.77-2.78l-.02.02Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1387.07 653.7s-3.5 13.2-4.05 21.66c-.47 7.1 3.29 33.12 3.29 33.12l23.76 2.16s-.68-26.3-1.4-37.26c-.72-10.96 1.12-22.44 1.12-22.44l-22.72 2.76Z"
        style={{
          fill: '#f4a019',
        }}
      />
      <path
        d="M1541.52 652.17s12.08-19.67 14.67-23.39 36.87-22.55 36.87-22.55 4.34 4 2.86 7.35c-1.48 3.33-4.09 7.04-4.09 7.04l19.3-7.42s5.51 3.35 2.25 7.21c-3.65 4.36-6.29 8.2-6.29 8.2l12.57-1.69s2.97 6.68-.74 10.4-9.64 6.65-9.64 6.65 8.14 1.53 8.14 4.13-3.71 5.95-3.71 5.95-26.36-.74-43.06 1.48c-16.7 2.23-29.14-3.35-29.14-3.35Z"
        style={{
          fill: '#d18850',
        }}
      />
      <path
        d="M1398.22 656.35c-12.08-.19-19.03 8.37-19.33 18.22-.3 10 7.74 17.48 17.93 17.04 9.94-.42 17.61-8.8 18.01-17.89.38-8.75-5.47-17.19-16.61-17.36Z"
        style={{
          fill: '#f4a019',
        }}
      />
      <path
        d="M1398.05 659.67c-9.87-.11-15.55 6.85-15.85 14.9-.3 8.24 6.29 14.45 14.71 14.13 8.26-.32 14.6-7.29 14.88-14.83.27-7.21-4.6-14.09-13.73-14.2h-.02Z"
        style={{
          fill: '#f1f1f3',
        }}
      />
      <path
        style={{
          fill: '#404b51',
        }}
        d="m1388.56 676.06 8.54-3.92 11.88 6.2-.67 1.09-11.15-5.73-8.08 3.52-.52-1.16z"
      />
    </svg>
  )
}

export default NoOpinionsDadEnd
